// @flow

import {connect} from 'react-redux';

import SimOrEsim from './SimOrEsim';
import { Platform } from 'react-native';
import {goToNextEsimPage, goToNextOrderPage, initializeSignUp} from '../../../modules/SignUp';

import {
  eSimSelectedSuccess,
  eSimSelectedSelector,
  fetchAvailableSim,
} from '../../../modules/ESim';
import {isLoggedInSelector} from '../../../modules/Authentication';

const mapStateToProps = state => ({
  nextPage: !isLoggedInSelector(state)
    ? 'createAccount'
    : Platform.OS === 'web'
      ? 'identityRequirements'
      : '',
  eSimSelected: eSimSelectedSelector(state),
});

const mapDispatchToProps = dispatch => ({
  goTo: (routeName?: string, params?: Object) => {
    dispatch(fetchAvailableSim('eSIM'));
    dispatch(goToNextEsimPage(routeName, params));
  },
  goToNextOrderPage: (routeName?: string) => {
    dispatch(goToNextOrderPage(routeName));
  },
  selectEsim: (selected?: Boolean) => {
    dispatch(eSimSelectedSuccess(selected));
  },
  initSignUp: () => {
    dispatch(initializeSignUp());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SimOrEsim);
